import React from 'react'

const ReportCard = ({icon,title,info}) => {
  return (
    <div className='box'>
    <img src={icon} alt="" />
    <h1 className='title'>{title}</h1>
    <p className='info'>{info}</p>
  </div>
  )
}

export default ReportCard